import {
  Component,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  BluePrismConnList,
  getCurrentBluePrismConn,
  ResetBluePrismState
} from './store/actions/rpa-blueprism-conn.actions';
import {
  getBluePrismConnList,
  getIsLoadingList
} from './store/selectors/rpa-blueprism-conn.selector';
import { Observable, Subscription } from 'rxjs';
import { BluePrismDetailWrapperComponent } from './blue-prism-detail-wrapper/blue-prism-detail-wrapper.component';
import { BotsListComponent } from '../shared/bots-list/bots-list.component';
import { RpaBotType, EListSelectionStatus } from 'app/rpa-bots/core/rpa-bots-type.enum';
import { PendingChangesService } from 'app/rpa-bots/core/pending-changes.service';
import { IAppState } from 'app/IAppState';
import { IRpaConnectionBluePrism } from '../core/IRpaBots';

@Component({
  selector: 'blue-prism',
  templateUrl: 'blue-prism.component.html',
  styleUrls: ['blue-prism.component.scss']
})
export class BluePrismComponent implements AfterViewInit {
  private _isLoadingListSubscription: Subscription;
  @ViewChild('bluePrismDetailWrapper', { static: false})
  private _bluePrismDetailWrapperComponent: BluePrismDetailWrapperComponent;
  @ViewChild('botsList', { static: false}) private _botsList: BotsListComponent;

  bluePrismList$: Observable<IRpaConnectionBluePrism[]>;
  isLoading$: Observable<boolean>;

  constructor(private _store: Store<IAppState>,
    private _pendingChangesService: PendingChangesService) {
    this.bluePrismList$ = this._store.pipe(select(getBluePrismConnList));
    this.isLoading$ = this._store.pipe(select(getIsLoadingList));
  }

  ngOnInit() {
    this._store.dispatch(new BluePrismConnList());
    this._isLoadingListSubscription = this.isLoading$.subscribe((isLoading: boolean) => {
      this._pendingChangesService.afterConnectorUpdated(isLoading);
    });
  }

  ngAfterViewInit() {
    this._pendingChangesService.initialize(this._store,
      this._bluePrismDetailWrapperComponent,
      this._botsList,
      RpaBotType.BluePrism,
      EListSelectionStatus.unselect);
  }

  ngOnDestroy(): void {
    this._store.dispatch(new ResetBluePrismState());
    if (this._isLoadingListSubscription) {
      this._isLoadingListSubscription.unsubscribe();
    }
  }

  onSelectedBotChanged(bot: IRpaConnectionBluePrism) {
    this._pendingChangesService.listSelectionStatus = EListSelectionStatus.loading;
    if (!!this._pendingChangesService.selectedConnector) {
      this._pendingChangesService.nextConnector = bot;
      this._pendingChangesService.check();
    } else {
      this._pendingChangesService.selectedConnector = bot;
      this._botsList.currentBot = bot;
      this._store.dispatch(new getCurrentBluePrismConn(bot.id));
    }
  }
}
